export default "__VITE_ASSET__5HsOQAQO__"